import { authHeader } from '../../_helpers';
import axios from 'axios';

export const userProfileService = {
    getUserProfileHandler,
    getDemographicDataHandler,
    updateBasicProfileHandler,
    updateAccountInfoHandler,
    updateAdditionalInfoHandler,
    updateDobInfoHandler,
    changePasswordHandler,
    setPasswordHandler,
    createProfileHandler,
    forgotPasswordHandler,
};
axios.defaults.headers.common = authHeader();

function getUserProfileHandler() {
    return axios.get(`/users/user/profile/view/`)
        .then(response => {
            return response;
        });
}

function getDemographicDataHandler() {
    return axios.get(`/masters/demographic/list/data/`)
        .then(response => {
            return response;
        });
}

function updateBasicProfileHandler(data) {
    return axios.post(`/users/update/user/basic/information/`, data)
        .then(response => {
            return response;
        });
}

function updateAccountInfoHandler(data) {
    return axios.post(`/users/update/user/account/information/`, data)
        .then(response => {
            return response;
        });
}

function updateAdditionalInfoHandler(data) {
    return axios.post(`/users/update/user/additional/information/`, data)
        .then(response => {
            return response;
        })
}

function updateDobInfoHandler(data) {
    return axios.post(`/users/update/user/dob/information/`, data)
        .then(response => {
            return response;
        })
}

function changePasswordHandler(data) {
    return axios.put(`/users/user/change/password/`, data)
        .then(response => {
            return response;
        })
}

function setPasswordHandler(data, call) {
    return axios[call](`/users/reset/password/${data.hashCode}/`, data.data)
        .then(response => {
            return response;
        })
}

function createProfileHandler(data) {


    return axios.post(`/users/user/profile/update/`, data)
        .then(response => {
            return response;
        })
}

function forgotPasswordHandler(data) {
    return axios.post(`/users/user/forgot/password/`, data)
        .then(response => {
            return response;
        })
}



// WEBPACK FOOTER //
// ./src/_services/userProfile/getUserProfile.service.js